import { Select } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledSelect = styled(Select)(({ theme }: any) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    height: '1.3rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.438rem',
      padding: '0.188rem 0.313rem',
    },
  },
  [theme.breakpoints.up('lg')]: {
    height: '1.75rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.625rem',
      padding: '0.25rem 0.438rem',
    },
  },
  [theme.breakpoints.up('xl')]: {
    height: '2.0rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.938rem',
      padding: '0.531rem 0.875rem',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    height: '2.5rem !important',
    '& .MuiSelect-select': {
      fontSize: '1rem !important',
      padding: '0.531rem 0.875rem',
    },
  },
}));

export const CustomizedSelect = styled(Select)(({ theme }: any) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    height: '1.3rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.438rem',
      padding: '0.188rem 0.313rem',
    },
  },
  [theme.breakpoints.up('lg')]: {
    height: '2.2rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.825rem',
      padding: '0.4rem 0.538rem',
    },
  },
  [theme.breakpoints.up('xl')]: {
    height: '2.5rem !important',
    '& .MuiSelect-select': {
      fontSize: '0.938rem',
      padding: '0.531rem 0.875rem',
    },
  },
  [theme.breakpoints.up('xxl')]: {
    height: '2.7rem !important',
    '& .MuiSelect-select': {
      fontSize: '1rem !important',
      padding: '0.531rem 0.875rem',
    },
  },
}));

export const menuItemCSS = {
  padding: {
    xxl: '1.1 !important',
    xl: '1 !important',
    lg: '0.5 !important',
    md: '0.3 !important',
  },
  fontSize: {
    xxl: '1.063rem !important',
    xl: '0.938rem !important',
    lg: '0.625rem !important',
    md: '0.5rem !important',
  },
};
